// BB Reveal — scroll-in reveals: JS only flips data attributes, bb-reveal.css does the motion
(function () {
  if (customElements.get('bb-reveal')) return;

  var reducedQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MAX_WORDS = 120; // past this a word stagger becomes a crawl — fall back to a whole fade

  class BBReveal extends HTMLElement {
    static get observedAttributes() { return ['data-bb-ready']; }

    connectedCallback() {
      if (this.dataset.bbSplit === 'words' && this.dataset.bbSplitDone === undefined) this.splitWords();
      this.prepare();
      this.dataset.bbReady = '';

      // Theme editor and reduced motion: show outright, nothing to watch
      if ((window.Shopify && Shopify.designMode) || reducedQuery.matches) {
        this.show(true);
        return;
      }

      // display: contents hosts have no box — observe the first child that does
      var target = this;
      for (var c = 0; c < this.children.length; c++) {
        if (this.children[c].getBoundingClientRect().height > 0) { target = this.children[c]; break; }
      }
      var self = this;
      this.observer = new IntersectionObserver(function (entries, observer) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          // Already scrolled past on load — reveal outright rather than replaying on the way back up
          self.show(entries[i].boundingClientRect.top < 0);
          observer.disconnect();
          self.observer = null;
        }
      }, { rootMargin: this.dataset.bbMargin || '0px 0px -15% 0px' });
      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
    }

    // A variant-switch morph can strip attributes off a live element — restore the shown state
    attributeChangedCallback(name, oldValue, newValue) {
      if (newValue === null && oldValue !== null && this.shown) {
        this.dataset.bbReady = '';
        this.show(true);
      }
    }

    // Items belonging to this host only, so nested reveals don't drive each other's items
    items() {
      var self = this;
      return Array.prototype.filter.call(this.querySelectorAll('[data-bb-item]'), function (el) {
        return el.parentElement.closest('bb-reveal') === self;
      });
    }

    show(instant) {
      this.shown = true;
      this.prepare();
      this.items().forEach(function (el) { el.dataset.bbShown = instant ? 'instant' : ''; });
    }

    // Re-run the reveal, e.g. after a filter swaps the item set
    replay() {
      this.items().forEach(function (el) {
        delete el.dataset.bbShown;
        el.style.removeProperty('--bb-index'); // items may have been reordered or filtered
      });
      void (this.firstElementChild || this).offsetWidth; // flush so the browser sees a fresh animation start
      this.show(false);
    }

    // Marks items, numbers them per group for stagger, and resolves data-bb-stagger-amount
    prepare() {
      // data-bb-items / data-bb-groups mark stock-rendered markup we can't attribute in Liquid
      var selector = this.dataset.bbItems;
      if (selector) {
        var found = this.querySelectorAll(selector);
        for (var i = 0; i < found.length; i++) found[i].dataset.bbItem = '';
      }
      var groupSelector = this.dataset.bbGroups;
      if (groupSelector) {
        var groups = this.querySelectorAll(groupSelector);
        for (var g = 0; g < groups.length; g++) groups[g].dataset.bbGroup = '';
      }

      var counts = new Map();
      var list = this.items();
      for (var j = 0; j < list.length; j++) {
        var item = list[j];
        var group = item.parentElement.closest('[data-bb-group]');
        if (!group || !this.contains(group)) group = this;
        var n = counts.get(group) || 0;
        counts.set(group, n + 1);
        if (!item.style.getPropertyValue('--bb-index')) item.style.setProperty('--bb-index', n);
      }

      var self = this;
      counts.forEach(function (count, group) {
        var amount = parseFloat(group.dataset.bbStaggerAmount || self.dataset.bbStaggerAmount);
        if (!isNaN(amount)) group.style.setProperty('--bb-stagger', (amount / Math.max(count - 1, 1)).toFixed(4) + 's');
      });
    }

    // Wraps each word in an inline-block item so lines still wrap naturally; rich text markup survives
    splitWords() {
      this.dataset.bbSplitDone = '';
      var walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
      var nodes = [];
      for (var n = walker.nextNode(); n; n = walker.nextNode()) nodes.push(n); // collect first — mutating mid-walk breaks the walker

      var total = 0;
      nodes.forEach(function (node) { total += node.textContent.split(/\s+/).filter(Boolean).length; });
      if (total === 0 || total > MAX_WORDS) {
        for (var c = 0; c < this.children.length; c++) this.children[c].dataset.bbItem = '';
        return;
      }

      nodes.forEach(function (node) {
        if (node.parentElement.closest('script, style')) return;
        var parts = node.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        parts.forEach(function (part) {
          if (!part.length) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          var span = document.createElement('span');
          span.className = 'bb-reveal__word';
          span.dataset.bbItem = '';
          span.textContent = part;
          frag.appendChild(span);
        });
        node.parentNode.replaceChild(frag, node);
      });
    }
  }

  customElements.define('bb-reveal', BBReveal);

  // Variant switches morph product markup in place, stripping our attributes — re-settle anything already shown
  document.addEventListener('variant:update', function () {
    document.querySelectorAll('bb-reveal').forEach(function (el) {
      if (el.shown) { el.dataset.bbReady = ''; el.show(true); }
    });
  });
})();
